import { render, staticRenderFns } from "./PromotionBundleEdit.vue?vue&type=template&id=6e2c9715&"
import script from "./PromotionBundleEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionBundleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports